<mat-tab-group (click)="onTabClick($event)" [selectedIndex]="getSelectedTabIndex()" class="tab-group-content">
  <mat-tab label="{{ isEditableBeneficiary() ? 'EDITAR BENEFICIÁRIO' : 'BENEFICIÁRIO' }}">
    <div class="company-card" *ngIf="hasCompany()">
      <div class="company-data">
        <div class="company-logo">
          <img src="./assets/icons/no-logo-company-icon.svg" />
          <div fxFlex fxLayout="column">
            <div class="company-name">{{ getCompany().getCorporateName() }}</div>
            <span class="company-cnpj"> CNPJ: {{ getCompany().getFiscalNumber() | companyFederalNumber }} </span>
          </div>
        </div>
        <span class="company-lives">Vidas: {{ getCompany().getCompanyInfo().getEmployeeCount() }}</span>
      </div>
    </div>
    <div [formGroup]="registrationBeneficiaryForm" class="registration-beneficiary-container" *ngIf="hasCompany()">
      <div class="card-number-container">
        <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <span *ngIf="hasCard()"><b>Número do Cartão: </b>{{ registrationBeneficiaryForm.get("cardNumber").value |
            cardNumberFormat }}</span>
          <mat-checkbox #enableDelivery fxFlex="40" formControlName="enableDelivery" labelPosition="after"
            matTooltip="Ao marcar esta opção, habilitara o Delivery no app Healthy IP.">
            Habilitar delivery
          </mat-checkbox>
        </div>
        <div *ngIf="hasCard() && isBeneficiaryCardBlocked()" class="card-status-container">
          <img src="./assets/icons/block-icon.svg" />
          <span>BLOQUEADO</span>
        </div>
      </div>
      <div>
        <div class="form-container" fxLayoutGap="10px">
          <mat-form-field fxFlex>
            <mat-label>CPF</mat-label>
            <input class="input-cpf" [readonly]="isEditableBeneficiary()" matInput formControlName="socialNumber"
              type="text" placeholder="CPF" [textMask]="{
                mask: socialNumberMask,
                guide: false,
                keepCharPositions: true
              }" required />
          </mat-form-field>
          <mat-form-field fxFlex="60">
            <mat-label>Nome</mat-label>
            <input [readonly]="!isEditableBeneficiary()" matInput formControlName="name" type="text" placeholder="Nome"
              (change)="onBeneficiaryInputChange()" required />
          </mat-form-field>
        </div>
        <div class="form-container">
          <div fxFlex="100">
            <mat-form-field fxFlex="25">
              <mat-label>Data de Admissão</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="admissionDate" type="text"
                placeholder="Data de Admissão" (change)="onBeneficiaryInputChange()" [textMask]="{
                  mask: dateMask,
                  guide: false,
                  keepCharPositions: true
                }" />
            </mat-form-field>

            <mat-form-field fxFlex="20">
              <mat-label>Matrícula</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="registration" type="text"
                placeholder="Matrícula" (change)="onBeneficiaryInputChange()" />
            </mat-form-field>

            <mat-form-field fxFlex [style.pointer-events]="isEditableBeneficiary() ? '' : 'none'">
              <mat-label>Cargo</mat-label>
              <mat-select formControlName="jobDescription" placeholder="Cargo">
                <mat-option *ngFor="let job of getJobList()" [value]="job">{{ job.getTitle() }}</mat-option>
                <mat-option (click)="openAddJobDescriptionDialog()" [value]="null">- Adicionar novo cargo -</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="100">
            <mat-form-field fxFlex>
              <mat-label>Data de Nascimento</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="birthDate" type="text"
                placeholder="Data de Nascimento" (change)="onBeneficiaryInputChange()" [textMask]="{
                  mask: dateMask,
                  guide: false,
                  keepCharPositions: true
                }" />
            </mat-form-field>

            <mat-form-field fxFlex [style.pointer-events]="isEditableBeneficiary() ? '' : 'none'">
              <mat-label>Sexo</mat-label>
              <mat-select formControlName="gender" placeholder="Sexo" (selectionChange)="onBeneficiaryInputChange()"
                required>
                <mat-option [value]="0">{{ genderType.Male }}</mat-option>
                <mat-option [value]="1">{{ genderType.Female }}</mat-option>
                <mat-option [value]="2">{{ genderType.Unknow }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field fxFlex [style.pointer-events]="isEditableBeneficiary() ? '' : 'none'">
              <mat-label>Estado Civil</mat-label>
              <mat-select formControlName="maritalStatus" placeholder="Estado Civil"
                (selectionChange)="onBeneficiaryInputChange()" required>
                <mat-option [value]="0">Casado</mat-option>
                <mat-option [value]="1">Solteiro</mat-option>
                <mat-option [value]="2">Divorciado</mat-option>
                <mat-option [value]="3">Viúvo</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="100">
            <mat-form-field fxFlex>
              <mat-label>Telefone</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="telephone" type="text"
                placeholder="Telefone" (change)="onBeneficiaryInputChange()" [textMask]="{
                  mask: telephoneMask,
                  guide: false,
                  keepCharPositions: true
                }" />
            </mat-form-field>

            <mat-form-field fxFlex>
              <mat-label>Celular</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="mobile" type="text"
                placeholder="Celular" (change)="onBeneficiaryInputChange()" [textMask]="{
                  mask: mobileMask,
                  guide: false,
                  keepCharPositions: true
                }" />
            </mat-form-field>
          </div>
          <div fxFlex="100">
            <mat-form-field fxFlex="20">
              <mat-label>CEP</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="zipCode" type="text"
                placeholder="CEP" (change)="onBeneficiaryInputChange()" (keyup)="getZipCode()" [textMask]="{
                  mask: zipCodeMask,
                  guide: false,
                  keepCharPositions: true
                }" />
            </mat-form-field>

            <mat-form-field fxFlex>
              <mat-label>Endereço</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="street" type="text"
                placeholder="Endereço" (change)="onBeneficiaryInputChange()" />
            </mat-form-field>

            <mat-form-field fxFlex="15">
              <mat-label>Número</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="number" type="text"
                placeholder="Número" (change)="onBeneficiaryInputChange()" />
            </mat-form-field>
          </div>
          <div fxFlex="100">
            <mat-form-field fxFlex="25">
              <mat-label>Complemento</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="complement" type="text"
                placeholder="Complemento" (change)="onBeneficiaryInputChange()" />
            </mat-form-field>
            <mat-form-field fxFlex="15" [style.pointer-events]="isEditableBeneficiary() ? '' : 'none'">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="region" placeholder="Estado" (selectionChange)="onStateInputChange()"
                required>
                <mat-option [value]="0">Selecione</mat-option>
                <mat-option *ngFor="let state of getStateList()" [value]="state">{{ state.getValue() }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field fxFlex [style.pointer-events]="isEditableBeneficiary() ? '' : 'none'">
              <mat-label>Cidade</mat-label>
              <mat-select formControlName="city" placeholder="Cidade" (selectionChange)="onBeneficiaryInputChange()"
                required>
                <mat-option [value]="0">Selecione</mat-option>
                <mat-option *ngFor="let city of getCityList()" [value]="city">{{ city.getName() }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field fxFlex>
              <mat-label>Bairro</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="district" type="text"
                placeholder="Bairro" (change)="onBeneficiaryInputChange()" required />
            </mat-form-field>
          </div>
          <div fxFlex="100">
            <mat-form-field fxFlex="70">
              <mat-label>E-mail</mat-label>
              <input [readonly]="!isEditableBeneficiary()" matInput formControlName="email" type="text"
                placeholder="E-mail" (change)="onBeneficiaryInputChange()" [required]="needValidateEmail.checked" />
            </mat-form-field>

            <mat-checkbox #needValidateEmail fxLayoutAlign="center center" fxFlex="30"
              formControlName="needValidateEmail" labelPosition="after"
              matTooltip="Ao marcar esta opção, o beneficiário deverá utilizar o mesmo email informado aqui quando for acessar o aplicativo.">
              Validar email no próximo acesso
            </mat-checkbox>
          </div>
          <div  fxLayoutAlign="start center">
              <mat-checkbox formControlName="transactionPasswordRequired" fxLayoutAlign="center center"
              labelPosition="after"
              matTooltip="Requer senha para efetuar transações">
              Permitir segurança transacional?
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="actions-container" *ngIf="hasCompany()">
      <div>
        <button mat-flat-button *ngIf="hasAccessToBeneficiaryBlockCard() && !isBeneficiaryCardCancelled()"
          class="cancel-card-btn" (click)="onCancelBeneficiaryCard()">
          CANCELAR CARTÃO
        </button>
      </div>

      <div class="actions-container2">
        <button mat-flat-button *ngIf="hasAccessToBeneficiaryBlockCard() && !isBeneficiaryCardCancelled()"
          class="order-card-btn" (click)="onOrderBeneficiaryCard()">
          2° VIA DE CARTÃO
        </button>
        <button mat-flat-button
          *ngIf="hasAccessToBeneficiaryBlockCard() && !isBeneficiaryCardCancelled() && !isBeneficiaryCardBlocked()"
          class="block-card-btn" (click)="openCardBlockDialog()">
          BLOQUEAR CARTÃO
        </button>
        <button mat-flat-button *ngIf="isEditableBeneficiary()" class="registrate-beneficiary-btn"
          (click)="saveBenficiary()">SALVAR BENEFICIÁRIO</button>
        <button mat-flat-button
          *ngIf="hasAccessToBeneficiaryReactivateCard() && !isBeneficiaryCardCancelled() && isBeneficiaryCardBlocked()"
          class="unblock-card-btn" (click)="openCardUnblockDialog()">
          DESBLOQUEAR CARTÃO
        </button>
        <button mat-flat-button
          *ngIf="isEditableBeneficiary() && !isBeneficiaryCardCancelled() && isBeneficiaryCardBlocked()"
          class="beneficiary-usage-btn" (click)="exportBeneficiaryUsageFile()">
          GERAR CONSUMO
        </button>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="LISTA DE DEPENDENTES">
    <div class="dependent-list-header">
      <span>Dependentes Cadastrados: {{ getDependents().length }}</span>

      <div *ngIf="isEditableBeneficiary()" class="registrate-dependent-btn" (click)="goToCreateDependent()">
        <span>REGISTRAR DEPENDENTE</span>
      </div>
    </div>

    <div class="dependent-list-container">
      <div class="dependent-card" style="margin-top: 2vh" *ngFor="let dependent of getDependents()">
        <div class="dependent-data">
          <div class="data-container">
            <div class="row-1">
              <p>{{ dependent?.getName() }}</p>
            </div>

            <div class="row-2">
              <span><b>Número do cartão: </b>{{ dependent?.getCard()?.getCardNumber() | cardNumberFormat }}</span>
              <div *ngIf="dependent.getCard().getIsBlocked()" class="card-status-container">
                <img src="./assets/icons/block-icon.svg" />
                <span>BLOQUEADO</span>
              </div>
            </div>

            <div class="row-3">
              <div class="data-column">
                <span><b>CPF: </b> {{ dependent?.getSocialNumber() | socialNumberFormatPipe }}</span>
                <span><b>Nascimento: </b> {{ dependent?.getBirthDate() | dateFormat }}</span>
              </div>

              <div class="data-column">
                <span><b>Sexo: </b> {{ dependent?.getGender()?.getView() }}</span>
                <span><b>Estado Civil: </b> {{ dependent?.getMaritalStatus()?.getView() }}</span>
              </div>

              <div class="data-column">
                <span><b>Celular: </b> {{ dependent?.getMobile() | mobileFormatPipe }}</span>
                <span><b>E-mail: </b> {{ dependent?.getEmail() }}</span>
              </div>
            </div>

            <div class="row-4">
              <div class="beneficiary-limit">
                <span><b>Limite: </b>{{ dependent.getLimit() | currencyPbmPipe }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-container">
          <div class="btn" [ngStyle]="{
              'background-color': dependent.isActive() ? '#2DCD7A' : 'darkgray'
            }">
            <mat-icon *ngIf="dependent.isActive()">check_circle_outline</mat-icon>
            <mat-icon *ngIf="!dependent.isActive()">clear</mat-icon>

            <span class="btn-title">{{ dependent.isActive() ? "ATIVO" : "INATIVO" }}</span>
          </div>
          <div class="btn" style="background-color: #f2950a" (click)="goToEditDependent(dependent)">
            <mat-icon aria-hidden="false">edit_note</mat-icon>
            <span class="btn-title">{{ isEditableBeneficiary() ? "EDITAR" : "VISUALIZAR" }}</span>
          </div>
          <div *ngIf="hasAccessToEditCycleLimit()" class="limit-btn" (click)="openModalDependentLimit(dependent)"
            aria-label="Alterar limite do dependente">
            <mat-icon aria-hidden="false">attach_money</mat-icon>
            <span class="btn-title">ALTERAR LIMITE</span>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>